import { IconProps } from "@amzn/awsui-components-react/polaris/icon";
import { StatusIndicatorProps } from "@amzn/awsui-components-react/polaris/status-indicator";

export function statusTypeToIcon(type: StatusIndicatorProps.Type): {
  name: IconProps.Name;
  variant: IconProps.Variant;
} {
  switch (type) {
    case "error":
      return { name: "status-negative", variant: "error" };
    case "warning":
      return { name: "status-warning", variant: "warning" };
    case "success":
      return { name: "status-positive", variant: "success" };
    case "info":
      return { name: "status-info", variant: "link" };
    case "stopped":
      return { name: "status-stopped", variant: "subtle" };
    case "pending":
      return { name: "status-pending", variant: "subtle" };
    case "in-progress":
      return { name: "status-in-progress", variant: "subtle" };
    default:
      return { name: "status-info", variant: "normal" };
  }
}
